import { INoteModel } from '../../../interfaces/INote';
import { IUserModel } from '../../../interfaces/IUser';
import { NoteList } from '../../notes/NoteList';
import { NoteTypes } from '../../../utilities/Constants';
import { useNoteCategoryTypes } from '../../../shared/react-query-hooks/useNoteCategoryTypes';
import { useZoneContext } from '../../../contexts/useZoneContext';

interface INotesRowProps {
    onAddNote: () => void;
    onNotesChanges: (notes: INoteModel[]) => void;
    onViewEditNote: (noteGuidToEdit: string, readOnly?: boolean | undefined) => void;
    notes: INoteModel[];
    user: IUserModel;
}
export function NotesRow(props: INotesRowProps) {
    const zoneContext = useZoneContext();
    const noteCategoryTypes = useNoteCategoryTypes();

    return (
        <td colSpan={3}>
            <NoteList
                user={props.user}
                notes={props.notes}
                noteCategoryTypes={noteCategoryTypes.data ?? []}
                handleViewEditNote={props.onViewEditNote}
                refreshParent={props.onNotesChanges}
                handleAddNote={props.onAddNote}
                showExpertsColumn
                zoneContext={zoneContext}
                noteType={NoteTypes.CaseNote}
            />
        </td>
    );
}
